import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestService} from '../../../shared/services/http-request.service';

@Injectable()
export class ImportTemplateService {
  private importTemplateApiUrl = `${environment.apiUrl}/ImportTemplate/`;
  private saveTemplateUrl= `${this.importTemplateApiUrl}SaveTemplate`;
  private getImportTemplatesUrl = `${this.importTemplateApiUrl}GetImportTemplates`;

  constructor(private http: HttpRequestService) {
  }

  saveTemplate(templateModel: any) {
    return this.http.post(this.saveTemplateUrl, templateModel);
  }

  getImportTemplates(clientId: number) {
    return this.http.get(this.getImportTemplatesUrl + `?clientId=${clientId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/import-csv/import-template.service.ts